import { Injectable, WritableSignal, effect, signal } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class RightSidebarService {
    rightSidebarOptions = RightSidebarOptions;
    selectedSidebar: WritableSignal<RightSidebarOptions> = signal(RightSidebarOptions.Closed);
    isOpen: WritableSignal<boolean> = signal(false);

    constructor() {
        effect(() => (this.selectedSidebar() !== RightSidebarOptions.Closed ? this.isOpen.set(true) : this.isOpen.set(false)));
    }

    closeSidebar(): void {
        this.selectedSidebar.set(RightSidebarOptions.Closed);
    }

    toggleSidebarVisibility(option: RightSidebarOptions): void {
        if (option === this.selectedSidebar()) {
            this.selectedSidebar.set(RightSidebarOptions.Closed);
        } else {
            this.selectedSidebar.set(option);
        }
    }
}

export enum RightSidebarOptions {
    Closed,
    Filter,
    Statistics,
    Favorites,
    AreaBuilder
}
